module.exports = __webpack_public_path__ + "static/MOiP-Desktop-1fbe9042819cfa41de8e5889150e8724.gif";